import { EmailsettingsService } from './../../_services/emailsettings.service';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditEmailTemplateComponent } from '../edit-email-template/edit-email-template.component';
import { LocalStorageService } from 'src/app/_services/local-storage.service';

@Component({
    selector: 'app-email-template',
    templateUrl: './email-template.component.html',
    styleUrls: ['./email-template.component.scss'],
    standalone: false
})
export class EmailTemplateComponent implements OnInit {

  customtemp: Array<any> = []
  emaillist: Array<any> = []
  successMessage: any;
  errorMessage: any;
  deleteid: any;

  @ViewChild('previewemail') previewemail: TemplateRef<any>;
  @ViewChild('deleteCustomTempalte') deleteCustomTempalte: TemplateRef<any>;
  psubject: any;
  pactionname: any;
  ptemplate: any;

  
  constructor(private emailsettings: EmailsettingsService,
    private modalService: NgbModal, private _localstorageservice : LocalStorageService) { }

  ngOnInit() {
    this.getEmailTemplate()
  }
  
  toastmessage(message ,type)
  {
    if(type == 'success'){
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    }else if (type == 'error')
    this.errorMessage = message;
      setTimeout(() => this.errorMessage = '', 5000);
  }

  getEmailTemplate() {
    this.emailsettings.getallEmailTemplate(this._localstorageservice.getItem('usernumber')) .subscribe((res: any) => {
      if (res.status == "success") {
        // this.emaillist = _.sortBy(res.message,function(email){
        //   return email.actionname.toLowerCase();
        // })
        this.customtemp = res.message
      }
      else {
        this.toastmessage('Something went wrong' , 'error')
      }
    })
  }


  openEmailCustomModal(email?: any) {
    const modalRef = this.modalService.open(EditEmailTemplateComponent, { size: 'lg' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    if (email) {
      modalRef.componentInstance.email = email;
    }
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      if (receivedEntry == 'added') {
        this.getEmailTemplate();
        this.toastmessage('Custom Email Template Created Successfully', 'success')
      } else if (receivedEntry == 'modify') {
        this.getEmailTemplate();
        this.toastmessage('Custom Email Template Updated Successfully', 'success')
      } else if (receivedEntry == 'error') {
        this.toastmessage('Something went wrong, Please try again in a minute' , 'error')
      }
    })
  }


  deleteCustomModal(email) {
    this.deleteid = email.templateid;
    const confirmRef = this.modalService.open(this.deleteCustomTempalte, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  deletecustom(){
   let data={
     template:{
     templateid: this.deleteid,
     isactive: 0,
     updatedby: this._localstorageservice.getItem('userid')
     },
     activitylog:[{
      action: "'update'",
      tablename: "'emailtemplate'",
      primarykeyid: this.deleteid,
      oldvalue: 1,
      newvalue: 0,
      updatedfieldname: "'isactive'",
      createdby: "'" + this._localstorageservice.getItem('userid') + "'" ,
      userid: "'" + this._localstorageservice.getItem('userid') + "'" ,
      usertype: "'user'",
     }]
   }

   this.emailsettings.updateEmailList(data).subscribe((res: any) => {
    if (res.status === "success") {
      this.getEmailTemplate();
      this.modalService.dismissAll();
      this.toastmessage('Email Template Deleted successfully' , 'success')
    } 
    else {
      this.modalService.dismissAll();
      this.toastmessage('Something went wrong' , 'error')
    }
  });
}

openPreviewEmailTemplateModal(email){
  this.emailsettings.getEmailDetails(email.templateid,this._localstorageservice.getItem('usernumber'))
  .subscribe((res: any) => {
    if (res.status == "success") {
      let response = res.message[0];
      this.psubject = response.subject;
      this.pactionname =  response.actionname;
      this.ptemplate = response.template;
    }
    else {
      this.toastmessage('Something went wrong' , 'error')
    }
  })
  const confirmRef = this.modalService.open(this.previewemail, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
}

}



